import SearchBoxWidget from './SearchBox';
import SearchResultHit from '@/components/searchResultsHit';
import { Hits } from 'react-instantsearch';
import { SearchBarProps } from '@/types/props/components';
import ConditionalRender from '../ConditionalRender';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
export default function SearchBar<T extends React.ElementType = 'div'>({
  as,
  searchContainerClassName,
  addButton = false,
  buttonProps,
  inputClassName,
  saveSearchQuery,
  isMobile = false,
  userId,
  ...containerProps
}: SearchBarProps<T>) {
  const { asPath } = useRouter();
  const Component = as || 'div';
  const [localShowResult, setLocalShowResult] = useState(false);
  const [searchBy, setSearchBy] = useState<'alphabet' | 'barcode'>('alphabet');

  function handleChangeSearchBy(type: 'alphabet' | 'barcode') {
    setSearchBy(type);
  }

  useEffect(() => {
    setLocalShowResult(false);
  }, [asPath]);

  return (
    <Component {...containerProps}>
      <SearchBoxWidget
        setShowResult={setLocalShowResult}
        addButton={addButton}
        searchContainerClassName={searchContainerClassName}
        buttonProps={buttonProps}
        inputClassName={inputClassName}
        saveSearchQuery={saveSearchQuery}
        userId={userId}
        handleChangeSearchBy={handleChangeSearchBy}
        searchBy={searchBy}
      />
      <ConditionalRender condition={localShowResult && isMobile === false}>
        <Hits
          hitComponent={SearchResultHit}
          classNames={{
            item: 'tw-w-full !tw-p-0 !tw-m-0 !tw-shadow-none',
            list: 'tw-overflow-y-scroll max-h-500 tw-bg-white tw-relative tw-z-50 tw-list-none',
          }}
        />
      </ConditionalRender>
    </Component>
  );
}
